import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

// import { AiChatConfig, AdditionalContext } from "shared-ai/ai-chat";
//import { AiChatConfig, AdditionalContext } from "shared-ai/ai-chat";
import { AiChatMessageStorage  } from "shared-ai/message-storage";
import { bootbox } from "../../infrastructure/bootbox-shim";
import { AdditionalContext, AiChatRequest, AiChatResponse } from "shared-ai/ai-chat";


const namespace: string = "profile";

// type ChatResponse = {
//     role: string, response: string, isFunctionExecution: boolean
// };

// type AIAssistantQuestionModel =
//     {
//         chatId: string,
//         question: string,
//         systemInstructions?: string[]
//     };


// type AIAssistantModelQuestionModel = AIAssistantQuestionModel &
// {
//     modelId: string;
//     nodePath: string;
// };


@Component
export default class AIAsssistant extends Vue {
    @Prop()
    modelId: string;

    @Getter("currentNodePath", { namespace: namespace })
    currentNodePath: string;

    @Action("setNodeModifiedNotification", { namespace: namespace })
    setNodeModifiedNotification: any;

    question: string = "";
    formattedChatComponentKey: number = 0;
    waitingForResponse: boolean = false;
    includeThinking: boolean = false;

    // Current progress status to display next to spinner
    currentProgressMessage: string = "";

    chatConfig = {
        // welcomeMessage: "Hello! I'm Joule, your AI assistant.  How can I help you today?",
        placeholder: "Enter your question here...",
        apiEndpoint: ("/api/1.0/aiassistant/chat"),
        maxConversationHistory: 20
    };

    sessionId: string = "";
    messageStore: AiChatMessageStorage = new AiChatMessageStorage(
        { messages: [] }
    );
    workingFiles: string[] = [];
    isLoadingWorkingFiles: boolean = false;
    isUploadingWorkingFiles: boolean = false;
    deletingWorkingFiles: Record<string, boolean> = {};
    allowedWorkingFileExtensions: string[] = [".csv", ".json", ".txt", ".xlsx"];

    mounted() { 
        // Generate a session ID for this component instance
        this.sessionId = this.generateSessionId();

        // if (!this.messageStore.hasMessages && this.chatConfig.welcomeMessage) {
        //     this.messageStore.addAssistantMessage(this.chatConfig.welcomeMessage)
        // }
        this.refreshWorkingFiles();
    }

    generateSessionId(): string {
        // Generate a UUID-like session ID manually for compatibility
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    async clearChat() {
        const doClear = await bootbox.confirm2("Clear messages and start a new chat session?");
        if (doClear) {

            // Clear server-side session
            try {
                await fetch('/api/1.0/aiassistant/chat/clear', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ sessionId: this.sessionId })
                });
            } catch (error) {
                console.error('Error clearing server session:', error);
            }

            // Clear client-side messages
            this.messageStore.clearMessages();

            // if (this.chatConfig.welcomeMessage) {
            //     this.messageStore.addAssistantMessage(this.chatConfig.welcomeMessage, this.sessionId);
            // }
        }
    }

    openWorkingFilePicker(): void {
        const fileInput = this.$refs.workingFileInput as HTMLInputElement | undefined;
        if (!fileInput || this.isUploadingWorkingFiles) return;

        fileInput.click();
    }

    async onWorkingFilesSelected(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;
        const files = input.files ? Array.from(input.files) : [];
        const validFiles = files.filter(file => this.isAllowedWorkingFile(file.name));

        if (validFiles.length > 0) {
            await this.uploadWorkingFiles(validFiles);
        }

        input.value = "";
    }

    isAllowedWorkingFile(fileName: string): boolean {
        const extension = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();
        return this.allowedWorkingFileExtensions.indexOf(extension) !== -1;
    }

    async uploadWorkingFiles(files: File[]): Promise<void> {
        this.isUploadingWorkingFiles = true;

        try {
            const formData = new FormData();
            files.forEach(file => formData.append("files", file));

            const response = await fetch("/api/1.0/aiassistant/working-file", {
                method: "POST",
                body: formData
            });

            if (response.ok) {
                await this.refreshWorkingFiles();
            } else {
                console.error("Failed to upload working files.");
            }
        } catch (error) {
            console.error("Error uploading working files:", error);
        } finally {
            this.isUploadingWorkingFiles = false;
        }
    }

    async refreshWorkingFiles(): Promise<void> {
        this.isLoadingWorkingFiles = true;
        try {
            const response = await fetch(
                "/api/1.0/aiassistant/working-file-list",
                { method: "get" },
            );

            if (response.ok) {
                this.workingFiles = (await response.json()) as string[];
            } else {
                this.workingFiles = [];
            }
        } catch {
            this.workingFiles = [];
        } finally {
            this.isLoadingWorkingFiles = false;
        }
    }

    async deleteWorkingFile(fileName: string): Promise<void> {
        if (!fileName) return;

        this.$set(this.deletingWorkingFiles, fileName, true);
        try {
            const response = await fetch(
                `/api/1.0/aiassistant/working-file?fileName=${encodeURIComponent(fileName)}`,
                { method: "DELETE" }
            );

            if (response.ok) {
                await this.refreshWorkingFiles();
            }
        } finally {
            this.$set(this.deletingWorkingFiles, fileName, false);
        }
    }

    isDeletingWorkingFile(fileName: string): boolean {
        return !!this.deletingWorkingFiles[fileName];
    }

    getWorkingFileUrl(fileName: string): string {
        return `/api/1.0/aiassistant/working-file?fileName=${encodeURIComponent(fileName)}`;
    }

    async sendMessageStream(): Promise<{ success: boolean; uiUpdates?: any }> {
        if (!this.question) return { success: false };

        this.scrollToShowChat();

        const messageToSend = this.question.trim();

        this.messageStore.addUserMessage(messageToSend, this.sessionId);
        this.question = "";

        const additionalContext: AdditionalContext[] = [];
        if (this.modelId) additionalContext.push({ title: "ModelId", content: this.modelId });
        if (this.currentNodePath) additionalContext.push({ title: "ActiveNodePath", content: this.currentNodePath });

        this.messageStore.addAssistantMessage("", this.sessionId);
        const placeholder = this.messageStore.messages[this.messageStore.messages.length - 1];

        this.waitingForResponse = true;
        this.currentProgressMessage = "";

        const payload: AiChatRequest = {
            conversationId: this.sessionId,
            message: messageToSend,
            includeThinking: this.includeThinking,
            context: { items: additionalContext }
        };

        try {
            const res = await fetch('/api/1.0/aiassistant/chat/stream', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!res.ok || !res.body) {
                const err = await res.text().catch(() => 'Request failed');
                placeholder.text = 'Error: ' + err;
                return { success: false };
            }

            const reader = res.body.getReader();
            const textDecoder = new TextDecoder();
            const parserState = { depth: 0, inString: false, isEscaped: false, current: "" };

            let assistantText = "";

            while (true) {
                const { value, done } = await reader.read();
                if (done) break;

                const chunk = textDecoder.decode(value, { stream: true });
                const streamedItems = this.parseChatStreamChunk(chunk, parserState);

                for (const item of streamedItems) {
                    if (!item || !item.message) continue;
                    assistantText += item.message;
                    placeholder.text = assistantText;
                    this.scrollToShowChat();
                }
            }

            const tailChunk = textDecoder.decode();
            const tailItems = this.parseChatStreamChunk(tailChunk, parserState);
            for (const item of tailItems) {
                if (!item || !item.message) continue;
                assistantText += item.message;
            }

            placeholder.text = assistantText || placeholder.text;
            this.currentProgressMessage = "";

            // Refresh working files after stream is fully received.
            await this.refreshWorkingFiles();

            return { success: true, uiUpdates: true };
        } catch (err) {
            console.error('Streaming error', err);
            placeholder.text = 'Sorry, I encountered an error while streaming the response. Please try again.';
            this.currentProgressMessage = "";
            return { success: false };
        } finally {
            this.waitingForResponse = false;
            this.currentProgressMessage = "";
        }
    }

    private parseChatStreamChunk(
        chunk: string,
        state: { depth: number; inString: boolean; isEscaped: boolean; current: string }
    ): AiChatResponse[] {
        const items: AiChatResponse[] = [];

        for (const ch of chunk) {
            if (state.depth === 0) {
                if (ch === '{') {
                    state.depth = 1;
                    state.current = "{";
                    state.inString = false;
                    state.isEscaped = false;
                }
                continue;
            }

            state.current += ch;

            if (state.inString) {
                if (state.isEscaped) {
                    state.isEscaped = false;
                } else if (ch === '\\') {
                    state.isEscaped = true;
                } else if (ch === '"') {
                    state.inString = false;
                }
                continue;
            }

            if (ch === '"') {
                state.inString = true;
            } else if (ch === '{') {
                state.depth++;
            } else if (ch === '}') {
                state.depth--;
                if (state.depth === 0) {
                    try {
                        items.push(JSON.parse(state.current) as AiChatResponse);
                    } catch {
                        // ignore malformed partial object
                    }
                    state.current = "";
                }
            }
        }

        return items;
    }

    scrollToShowChat() {

        //        divElement.animate({ scrollTop: Number.MAX_SAFE_INTEGER }, { delay: 0 });
        //        divElement.scrollTop = divElement.scrollHeight;

        //chatBox.animate({ scrollTop: Number.MAX_SAFE_INTEGER }, { delay: 0 });
        const chatBox = document.getElementById('chatbox');
        chatBox.scrollTop = chatBox.scrollHeight;
        //                        questionInput.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

    }



    getQuestionInputPlaceholder(): string {

        var result = "Enter your question";

        if (this.modelId)
            result += ` (model: ${this.modelId})`;

        if (this.currentNodePath)
            result += `, path: ${this.currentNodePath}`;

        return result;

    }

    async onQuestionEnterPress() {

        const result = await this.sendMessageStream();

        if (this.modelId && this.currentNodePath && result.uiUpdates) {
            // Trigger refresh of diagram and tree
            this.setNodeModifiedNotification(this.currentNodePath);
        }

    }


    formatTime(date: Date): string {
        return new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(date)
    }

    formatMessage(text: string): string {
        return text.replace(/\n/g, '<br/>');
    }

    /**
     * Format message with enhanced styling for progress/status messages.
     * Progress messages are wrapped in square brackets like [Analyzing your request...]
     */
    formatMessageWithProgress(text: string): string {
        if (!text) return '';

        // Split by newlines first to preserve line breaks
        const lines = text.split('\n');

        const formattedLines = lines.map(line => {
            // Check if line is a progress message (wrapped in square brackets)
            const progressMatch = line.match(/^\[(.+?)\]$/);

            if (progressMatch) {
                // Style progress messages with muted styling and icon
                const progressText = progressMatch[1];
                return `<div class="ai-progress-message">
                    <span class="ai-progress-icon">⏳</span>
                    <span class="ai-progress-text">${this.escapeHtml(progressText)}</span>
                </div>`;
            } else {
                // Regular text - escape HTML and preserve formatting
                return this.escapeHtml(line);
            }
        });

        return formattedLines.join('<br/>');
    }

    /**
     * Escape HTML to prevent XSS while allowing our custom HTML for progress messages
     */
    private escapeHtml(text: string): string {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}


//class JsonStreamDecoder {
//    /** item starts and ends at level 0 */
//    private level = 0;

//    /** when an item is split in two */
//    private partialItem = '';

//    private decoder = new TextDecoder();

//    public decodeChunk<T>(
//        value: Uint8Array,
//        decodedItemCallback: (item: T) => void
//    ): void {

//        const JTOKEN_START_OBJECT = '{';
//        const JTOKEN_END_OBJECT = '}';

//        const chunk = this.decoder.decode(value);
//        let itemStart = 0;

//        for (let i = 0; i < chunk.length; i++) {
//            if (chunk[i] === JTOKEN_START_OBJECT) {
//                if (this.level === 0) {
//                    itemStart = i;
//                }
//                this.level++;
//            }
//            if (chunk[i] === JTOKEN_END_OBJECT) {
//                this.level--;
//                if (this.level === 0) {
//                    let item = chunk.substring(itemStart, i + 1);
//                    if (this.partialItem) {
//                        item = this.partialItem + item;
//                        this.partialItem = '';
//                    }
//                    decodedItemCallback(JSON.parse(item));
//                }
//            }
//        }
//        if (this.level !== 0) {
//            this.partialItem = chunk.substring(itemStart);
//        }
//    }
//}





// WEBPACK FOOTER //
// ./ClientApp/components/ai-assistant/ai-assistant.ts